
import { supabase } from '@/integrations/supabase/client';

export const policyService = {
  // Check for policy conflicts
  async checkPolicyConflicts(): Promise<any[]> {
    try {
      const { data, error } = await supabase.rpc('check_policy_conflicts');
      
      if (error) {
        console.error('Error checking policy conflicts:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error in checkPolicyConflicts:', error);
      return [];
    }
  }
};
